import * as React from 'react';
import { useDispatch} from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useGetAngelProfileQuery, useLogoutMutation } from "../../../slices/usersApiSlice";
import { setLogout } from '../../../slices/authSlice';
import { Button, Dropdown } from 'antd';
import { LogoutOutlined, MailOutlined, RubyOutlined, SettingOutlined, UserOutlined,SyncOutlined } from '@ant-design/icons';
import {useState} from "react";
import SimpleDialogDemo from '../zerodhaDilogbox';
import angelone from "../../../images/angelone.png";

export default function ProfileMenu(props) {
  const {collapsed, screens, userInfo} = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [logoutmu] = useLogoutMutation();
 
    const [clicked, setClicked] = useState(false);
const [isMobile1, setIsMobile] = useState(window.innerWidth < 768);

    // const { userInfo } = useSelector((state) => state.auth);
    const userId = userInfo?._id || localStorage.getItem('userId');
    const { data: angelProfile, error: angelError } = useGetAngelProfileQuery(userId);
    const handlelogout = async() => {
        clicked ? setClicked(false) : setClicked(true)
        const res = await logoutmu();
        dispatch(setLogout({ ...res }));
        window.location.href = "/Login";
    }

    const items = [
      {
        label: <span style={{color: "#000"}}>{userInfo.firstname + " " + userInfo.lastname}</span>,
        key: '0',
        icon: <UserOutlined style={{color: "#000"}}/>,
      },
      {
        label: <span style={{color: "#000"}}>{userInfo.email}</span>,
        key: '1',
        icon: <MailOutlined style={{color: "#000"}}/>,
      },
      {
        type: 'divider',
      },
      {
        label: <Link to={"/Profile"} style={{color: "#000"}}>Profile </Link>,
        key: '2',
        icon: <UserOutlined style={{color: "#000"}}/>,
        to: "/Profile"
      },
      {
        label: <Link to={"/Subscription"} style={{color: "#000"}}>My Subscriptions </Link>,
        key: '3',
        icon: <RubyOutlined style={{color: "#000"}}/>,
        to: "/Subscription"
      },
      {
        type: 'divider',
      },
      {
        label: <Link onClick={handlelogout} style={{color:"#e74c3c"}}>Logout</Link>,
        key: '4',
        icon: <LogoutOutlined style={{color:"#e74c3c"}}/>
      },
    ];
    
    const handleClick = (e) => {
      e.preventDefault()
      clicked ? setClicked(false) : setClicked(true)
    }
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={['hover']}
    >
      <Button
            type="text"
            shape='circle'
            icon={<SettingOutlined className={"iconrotate"} />}
            onClick={(e) => handleClick(e)}
            style={{
                fontSize: '16px',
                display:  `${collapsed || screens.lg ? '' : 'none'}`
            }}
            />
    </Dropdown>
  );
}